import { Injectable } from '@angular/core';
import { BaseHttpService } from '@shared/services/base-http.service';
import { Observable } from 'rxjs';
import { Response } from '@shared/models/response.model';
import { map } from 'rxjs/operators';
import { SuccessRes } from '@shared/interfaces/success-res.interface';

@Injectable({
  providedIn: 'root',
})
export class FooterService {
  constructor(public baseHttp: BaseHttpService) {}

  sendContactForm(pack, type): Observable<Response<SuccessRes>> {
    return this.baseHttp
      .post('/contact/' + type, pack)
      .pipe(map((resp) => resp as Response<SuccessRes>));
  }
  ukrainianSendContactForm(pack): Observable<Response<SuccessRes>> {
    return this.baseHttp
      .post('/contact/direct_message', pack)
      .pipe(map((resp) => resp as Response<SuccessRes>));
  }
}
